import moment from "moment";
import StatBox from "pages/Analytics/elements/StatBox";
import { useEffect, useState } from "react";
import { apiRequest } from "utils/api";

const BorrowersCreatedCount = () => {
  const [count, setCount] = useState(0);

  async function onLoad() {
    try {
      const { users } = await apiRequest("/supabase/borrowers/select", {
        type: "borrower",
        created_at: {
          start: moment().subtract(30, "days").toDate(),
          end: moment().toDate(),
        },
      });
      setCount(users.length);
    } catch (err) {
      console.error(err);
    } finally {
      //   setLoading(false);
    }
  }

  useEffect(() => {
    onLoad();
  }, []);

  return (
    <StatBox
      title="New Borrowers"
      stat={count}
      description="in the last 30 days"
    />
  );
};

export default BorrowersCreatedCount;
